import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/components/AfterResultBot.css";
import "../../styles/components/ComparisonTable.css";
import omnicareLogo from "../../assets/icons/logo.svg";
import doctorImage from "../../assets/images/doctor.png";
import backIcon from "../../assets/icons/back.svg";
import LanguageSwitcher from "../LanguageSwitcher";

const AfterQuiz5 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/after-quiz/4");
  };
  return (
    <div className="after-result-bot-container">
      {/* Header */}
      <header className="after-result-bot-header">
        <div className="logo-section">
          <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: 'pointer' }}>
            <img src={omnicareLogo} alt="Pebble Health Logo" className="logo-icon" />
            <span className="logo-text">Pebble Health</span>
          </div>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
          <div className="back-button" onClick={handleBack}>
            <img src={backIcon} alt="Back" className="back-icon" />
          </div>
        </div>
      </header>

      {/* Doctor illustration above divider */}
      <div className="doctor-divider">
        <img src={doctorImage} alt="Dr. Sam" className="doctor-avatar" />
      </div>

      <div className="after-result-bot3-content comparison-content">
        <h2 className="congrats-text">{t("afterQuiz.step5.comparisonTitle")}</h2>

        {/* Best-for summary on top */}
        <div className="best-for-section">
          <ul className="best-for-list">
            <li>
              <span className="best-for-label">Quick consultation with insurance coverage:</span>
              {' '}<a className="info-link" href="https://www.teladoc.com/" target="_blank" rel="noopener noreferrer">Teladoc Health</a>
            </li>
            <li>
              <span className="best-for-label">Affordable pay‑per‑visit without insurance:</span>
              {' '}<a className="info-link" href="https://sesamecare.com/" target="_blank" rel="noopener noreferrer">Sesame Care</a>
            </li>
            <li>
              <span className="best-for-label">Hybrid care with online & in‑person options:</span>
              {' '}<a className="info-link" href="https://carbonhealth.com/" target="_blank" rel="noopener noreferrer">Carbon Health</a>
            </li>
          </ul>
        </div>

        <h2 className="congrats-text">{t("afterQuiz.step5.detailedComparison")}</h2>
        <div className="comparison-table-wrapper">
          <table className="comparison-table" role="table">
            <thead>
              <tr>
                <th scope="col">{t("afterQuiz.step5.service")}</th>
                <th scope="col">{t("afterQuiz.step5.advantages")}</th>
                <th scope="col">{t("afterQuiz.step5.disadvantages")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="service-cell"><a className="info-link" href="https://www.teladoc.com/" target="_blank" rel="noopener noreferrer">Teladoc Health</a></td>
                <td>
                  24/7 access to board‑certified doctors. Covers general medical, dermatology, and mental health. Accepts many insurance plans. Can prescribe medication.
                </td>
                <td>
                  Requires an account before use. Prices may vary based on insurance coverage. No in‑person care options.
                </td>
              </tr>
              <tr>
                <td className="service-cell"><a className="info-link" href="https://sesamecare.com/" target="_blank" rel="noopener noreferrer">Sesame Care</a></td>
                <td>
                  Pay‑per‑visit model (no subscriptions) with transparent upfront pricing. Often cheaper for uninsured users. Covers urgent care, mental health, and prescriptions. No insurance required.
                </td>
                <td>
                  Limited availability of providers in some regions. Does not accept insurance. No direct integration with primary care providers.
                </td>
              </tr>
              <tr>
                <td className="service-cell"><a className="info-link" href="https://carbonhealth.com/" target="_blank" rel="noopener noreferrer">Carbon Health</a></td>
                <td>
                  Hybrid model (online + in‑person care). Can schedule in‑person follow‑ups at clinics. Covers primary care, urgent care, mental health, and testing. Accepts some insurance plans.
                </td>
                <td>
                  Availability varies by location. Not always the fastest option for online consultations. Prices can be higher compared to other telehealth services.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AfterQuiz5;
